module.exports = __webpack_public_path__ + "img/tsmap.4dc60c3e.png";